<div class="col-md-12 col-lg-12">
  <div class="col-sm-3"><h4><b>{{ 'pages.createReceiptPage.productType' | translate }}</b></h4></div>
  <div *ngIf="!isOpen">
    <div class="col-sm-3"><h4>{{selectedProductType}}</h4></div>
    <div class="col-sm-3"><h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{ 'common.change' | translate }}</h4></div>
  </div>
</div>
<div *ngIf="isOpen" class="mrgin-lft" >
  <div class="col-md-2 col-sm-10" *ngFor="let item of productTypes; index as i">
    <button class="btn btn-lg btn-mode" (click)="selectProductType(item)"><span class="box-title">{{item.Code}}</span><p class="sub-box">{{item.Description}}</p></button>
  </div>
</div>

